import { AuthRepository } from '@domain/auth/repositories/auth.repository';
import { AuthRepositoryService } from '../repositories/auth.repository.service';

export const AuthProvider = [
  {
    provide: AuthRepository,
    useClass: AuthRepositoryService,
  },
];
